var _a;
import * as baseTheme from "@bottlebooks/design-tokens";
import label from "../components/Label/labelVariants";
import link from "../components/Link/linkVariants";
import p from "../components/Text/pVariants";
import text from "../components/Text/textVariants";
import title from "../components/Title/titleVariants";
import input from "../components/Input/inputVariants";
import card from "../components/Card/cardVariants";
const theme = Object.assign(Object.assign({}, baseTheme), { shadows: Object.assign({ 
        // Single pixel shadow. The color is set statically, so it needs to be overridden if the border color is changed.
        border: `0 0 0 1px ${(_a = baseTheme.colors) === null || _a === void 0 ? void 0 : _a.border}` }, baseTheme.shadows), input,
    label,
    link,
    p,
    text,
    title,
    card });
export default theme;
//# sourceMappingURL=index.js.map